<template>
  <div class="m-newage">
    <template v-if="!loading">
      <div class="m-newage__hero" v-observe-visibility="observeVisibilitySettings(0, 'Header')">
        <div class="m-newage__hero__logo"></div>
        <div class="m-newage__hero__description">
          The New Age of MapleStory continues with war on the Battleship Arteria, an expedition into Minar, adventures
          in Carcion, the Cradle of Life, and more!
        </div>
        <div class="m-newage__hero__play" @click="playFree">
          <span>Play Free</span>
        </div>
        <a
          href="https://maplestory.nexon.net/news/86907/v-246-new-age-6th-job-patch-notes"
          target="_blank"
          class="m-newage__hero__patch"
          @click="
            clickTracking({
              interaction: 'link_click',
              sectionNumber: 0,
              sectionName: 'Header',
              sectionContent: 'v.246 Patch Notes',
            })
          "
          >Go to v.246 Patch Notes!</a
        >
        <a
          href="https://maplestory.nexon.net/news/87688"
          target="_blank"
          class="m-newage__hero__patch"
          @click="
            clickTracking({
              interaction: 'link_click',
              sectionNumber: 0,
              sectionName: 'Header',
              sectionContent: 'v.247 Patch Notes',
            })
          "
          >Go to v.247 Patch Notes!</a
        >
      </div>

      <div class="m-newage__content">
        <!-- section 1 -->
        <div
          class="m-newage__content__section m-newage__content__section-1"
          v-observe-visibility="observeVisibilitySettings(1, 'Abyssal Expedition')"
        >
          <div class="m-newage__content__section__title">Abyssal Expedition</div>
          <div class="m-newage__content__section__description">Available Now!</div>
          <div class="m-newage__content__section__text">
            Join a special expedition delving into the darkest recesses of Maple World! Lead a team of powerful warriors
            and brave explorers as you uncover the mysteries of Minar in a special, limited time event!
          </div>
          <div class="m-newage__content__section__image m-newage__content__section__image--big" />
        </div>

        <!-- section 2 -->
        <div
          class="m-newage__content__section m-newage__content__section-2"
          v-observe-visibility="observeVisibilitySettings(2, 'Battleship Arteria')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">Battleship Arteria</div>
          <div class="m-newage__content__section__description">Available Now!</div>
          <div class="m-newage__content__section__text">
            Reina, the new Apostle of Darmoor, carries the power of a god within a special crystal. High aboard the
            sinister warship, she prepares to invade Maple World with the High Flora army! Continue MapleStory's epic
            tale in a new zone for&nbsp;high-level Maplers, as you board the Arteria and take the battle to the sky!
          </div>
          <div class="m-newage__content__section__image m-newage__content__section__image--big" />
        </div>

        <!-- section 3 -->
        <div
          class="m-newage__content__section m-newage__content__section-3"
          v-observe-visibility="observeVisibilitySettings(3, 'Carcion')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">New Zone - Carcion</div>
          <div class="m-newage__content__section__description">Arrives on January 9</div>
          <div class="m-newage__content__section__text">
            Set forth into a new area on Grandis: Carcion, the&nbsp;Cradle of Life! Join forces with the local residents
            to protect Carcion from Darmoor’s apostle who seeks the power of the ancient god,&nbsp;Keira!
          </div>
          <div class="m-newage__content__section__image m-newage__content__section__image--big" />
        </div>

        <!-- section 4 -->
        <div
          class="m-newage__content__section m-newage__content__section-4"
          v-observe-visibility="observeVisibilitySettings(4, 'New Difficulties')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">New Difficulties for Kaling and Kalos the Guardian</div>
          <div class="m-newage__content__section__description">Available Now!</div>
          <div class="m-newage__content__section__text">
            Challenge two of MapleStory's newest bosses on Easy, Chaos, and Extreme difficulties, and claim the powerful
            new Helmet of Loyalty and Mark of Destruction items from Kaling and Kalos the Guardian on Extreme
            difficulty!
          </div>
          <div class="m-newage__content__section__image m-newage__content__section__image--big" />
        </div>

        <!-- section-5 -->
        <div
          class="m-newage__content__section m-newage__content__section-5"
          v-observe-visibility="observeVisibilitySettings(5, '6th Job and Hexa', 0.08)"
        >
          <div class="m-newage__content__section__divider"></div>
          <!-- section 5-1 -->
          <div class="m-newage__content__section m-newage__content__section-5-1">
            <div class="m-newage__content__section__title">6th Job and the Hexa Matrix</div>
            <div class="m-newage__content__section__description">Available Now!</div>
            <div class="m-newage__content__section__text">
              As the boundary between Maple World and Grandis is sundered, a new form of Erda has been unleashed. Taming
              this new power will do more than save the goddesses of the two worlds: it will unlock skills never seen
              before in either land.
            </div>
            <div class="m-newage__content__section__text">
              6th Job Advancement will become available at Lv.&nbsp;260, with completion of the "[Convergence] True
              Form" quest.
            </div>
            <div class="m-newage__content__section__image" />
          </div>

          <!-- section 5-2 -->
          <div class="m-newage__content__section m-newage__content__section-5-2">
            <div class="m-newage__content__section__left">
              <div class="m-newage__content__section__subtitle">Hexa Skill Matrix</div>
              <div class="m-newage__content__section__text">
                The 6th Job skills are managed through the Hexa Matrix which is separated into HEXA Skills and HEXA
                Stats. The Origin Skill obtained from the HEXA Skills boasts&nbsp;an impressive, powerful
                new&nbsp;cutscene.
              </div>
              <div class="m-newage__content__section__text">
                The Hexa Matrix allows you to unlock and slot in a variety of nodes. These range from
                <span>Skill Nodes</span> that feature the unstoppable 6th Job skills, <span>Mastery Nodes</span> which
                greatly enhance or outright replace your 4th Job skills, and <span>Boost Nodes</span>
                to give your 5th Job skills more punch.
              </div>
            </div>
            <div class="m-newage__content__section__right">
              <div class="m-newage__content__section__image" />
            </div>
          </div>

          <!-- section 5-3 -->
          <div class="m-newage__content__section m-newage__content__section-5-3">
            <div class="m-newage__content__section__left">
              <div class="m-newage__content__section__image" />
            </div>
            <div class="m-newage__content__section__right">
              <div class="m-newage__content__section__subtitle">Hexa Stat Matrix</div>
              <div class="m-newage__content__section__text">
                The Hexa Matrix empowers you as well as your skills, with dynamic bonuses to your preferred stats right
                at your fingertips!
              </div>
              <div class="m-newage__content__section__text">
                A Hexa Stat Node allows you to grant a bonus to three stats of your choice: one primary gaining the
                biggest increase along with two secondary stats. Each time you level up these nodes, one of the chosen
                stats will be enhanced, making you even stronger.
              </div>
            </div>
          </div>

          <!-- section 5-4 -->
          <div class="m-newage__content__section m-newage__content__section-5-4">
            <div class="m-newage__content__section__left">
              <div class="m-newage__content__section__subtitle">6th Job Skills</div>
              <div class="m-newage__content__section__text">
                The Hexa Matrix can provide many abilities for your characters, but the most potent of them all are the
                new 6th Job skills. With a different skill for&nbsp;each class,&nbsp;these abilities will make you
                briefly&nbsp;invulnerable as you annihilate anything&nbsp;in your way. Check out the 6th Job skills
                video for a&nbsp;preview!
              </div>
            </div>
            <div class="m-newage__content__section__right">
              <div
                class="m-newage__content__section__image m-newage__content__section__image--video"
                @click="openModal('vfKP8EaAkvE')"
              />
            </div>
          </div>

          <!-- section 5-5 -->
          <div class="m-newage__content__section m-newage__content__section-5-5">
            <div class="m-newage__content__section__left">
              <div class="m-newage__content__section__image m-newage__content__section__image-1" />
              <div class="m-newage__content__section__image m-newage__content__section__image-2" />
            </div>
            <div class="m-newage__content__section__right">
              <div class="m-newage__content__section__subtitle">Sol Erda: The Sixth Power</div>
              <div class="m-newage__content__section__text">
                The 6th Job advancement is now available. Maple World and Grandis merged into one with the Convergence
                incident after the disappearance of the Black Mage. An immense energy broke out and a new power called
                “Sol Erda” appeared as the Erda making up the two worlds mixed. Finding out how to control this new
                power is the start of the 6th Job advancement story.
              </div>
            </div>
          </div>
        </div>

        <!-- section 6 -->
        <div
          class="m-newage__content__section m-newage__content__section-6"
          v-observe-visibility="observeVisibilitySettings(6, 'Identisk')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">Identisk Exploration</div>
          <div class="m-newage__content__section__description">Available Now!</div>
          <div class="m-newage__content__section__text">
            The frosty island of Iden and the sun-kissed isle of Tisk have collided to form a new land mass, but with
            one mysterious consequence: The divine blessing over Iden has faded. Explore Identisk Island in this
            limited-time event during the New Age update to seek out this blessing and earn a wealth of special rewards!
          </div>
          <div class="m-newage__content__section__image" />
        </div>

        <!-- section 7 -->
        <div
          class="m-newage__content__section m-newage__content__section-7"
          v-observe-visibility="observeVisibilitySettings(7, 'Hyper Burn')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">Hyper Burn to Lv. 260!</div>
          <div class="m-newage__content__section__description">Available Now!</div>
          <div class="m-newage__content__section__text">
            Hyper Burning and the Burning World are back for another round, and this time the fires burn even hotter!
            Level up to Lv. 260 with massive EXP bonuses and bonus levels gained every time you level up, and climb
            towards the 6th Job on a brand new character!
          </div>
          <div class="m-newage__content__section__image" />
        </div>

        <!-- section 8 -->
        <div
          class="m-newage__content__section m-newage__content__section-8"
          v-observe-visibility="observeVisibilitySettings(8, 'Better Maple')"
        >
          <div class="m-newage__content__section__divider"></div>

          <div class="m-newage__content__section__title">More Changes for a Better Maple</div>
          <div class="m-newage__content__section__description">Available Now!</div>

          <div class="m-newage__content__section__images-wrapper">
            <div class="m-newage__content__section__image m-newage__content__section__image-1" />
            <div class="m-newage__content__section__image m-newage__content__section__image-2" />
            <div class="m-newage__content__section__image m-newage__content__section__image-3" />
          </div>

          <div class="m-newage__content__section__text">
            <div class="m-newage__content__section__text__highlight">Arcane River and Grandis Revamp</div>
            <p>More EXP in Arcane River Daily Quests and lowered&nbsp;Sacred Power requirements!</p>
          </div>

          <div class="m-newage__content__section__text">
            <div class="m-newage__content__section__text__highlight">Tower of Oz Witch Shop Update</div>
            <p>Special skill rings originally obtainable from Tower of Oz will be obtainable from Boss monsters.</p>
          </div>

          <div class="m-newage__content__section__text">
            <div class="m-newage__content__section__text__highlight">Level Up Adjustments</div>
            <p>Level up faster than ever before with an adjusted EXP curve from Lv. 200 to Lv. 260.</p>
            <p>
              We've also made EXP adjustments outside of that curve to make hunting and leveling up easier
              than&nbsp;ever!
            </p>
          </div>

          <div class="m-newage__content__section__more">And More!</div>
        </div>
      </div>

      <Footer
        color="#5bd1ef"
        hoverColor="#ffffff"
        backgroundColor="#5f1f97"
        v-observe-visibility="observeVisibilitySettings(9, 'Footer')"
        @go-to-main-click="
          clickTracking({
            interaction: 'link_click',
            sectionNumber: 9,
            sectionName: 'Footer',
            sectionContent: 'Main Site',
          })
        "
        @link-click="
          (name) =>
            clickTracking({
              interaction: 'link_click',
              sectionNumber: 9,
              sectionName: 'Footer',
              sectionContent: name,
            })
        "
      />
    </template>

    <transition name="modal" appear @after-leave="afterModalClose">
      <aside
        v-if="showModal"
        ref="modal"
        class="m-newage__modal"
        tabindex="-1"
        @keyup.esc="closeModal"
        @click.self="closeModal"
      >
        <dialog open class="m-newage__modal__dialog">
          <div class="m-newage__modal__dialog__close" @click.self="closeModal" />
          <!-- :src="`https://www.youtube.com/embed/${youtubeId}?playlist=${youtubeId}&loop=1&rel=0&mute=1&autoplay=1`" -->
          <iframe
            width="100"
            height="100"
            :src="`https://www.youtube.com/embed/${youtubeId}?mute=1&autoplay=1`"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;fullscreen;"
          />
        </dialog>
      </aside>
    </transition>
  </div>
</template>

<script>
import Util from '@/services/browser/Util'
import Cookie from '@/services/browser/Cookie'
import Responsive from '@/services/browser/Responsive'
import Footer from '@/components/microsites/Footer.vue'
import { defineComponent } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import '@/assets/scss/microsites/newAge/newAge.scss'

export default defineComponent({
  directives: {
    'observe-visibility': ObserveVisibility,
  },
  name: 'Microsite New Age',
  components: {
    Footer,
  },
  props: {},
  data() {
    return {
      loading: true,
      showModal: false,
      youtubeId: '',
    }
  },
  mounted() {
    Responsive.init()
    setTimeout(() => {
      // wait for the responsive init
      this.loading = false

      window.dataLayer.push({
        pageType: 'Microsite',
        micrositeName: 'New Age',
        micrositePhase: '2-2',
      })
    }, 210)
    Cookie.set('maplenewage', 'true')
  },
  methods: {
    playFree() {
      Util.playFree()
      this.clickTracking({
        interaction: 'button_click',
        sectionNumber: 0,
        sectionName: 'Header',
        sectionContent: 'Play Free CTA',
      })
    },
    observeVisibilitySettings(id, name, threshold = 0.2) {
      return {
        callback: (isVisible) => (isVisible ? this.viewTracking({ id, name }) : null),
        intersection: { threshold: threshold },
        throttle: 1000,
        once: true,
      }
    },
    clickTracking({ interaction, sectionNumber, sectionName, sectionContent, specialValue }) {
      window.dataLayer.push({
        event: 'standardMicrositeTrackingEvent',
        interaction: interaction,
        micrositeSectionNumber: sectionNumber,
        micrositeSectionName: sectionName,
        micrositeSectionContent: sectionContent,
        ...(specialValue ? { micrositeSpecialValue: specialValue } : {}),
      })
    },
    viewTracking({ id, name }) {
      window.dataLayer.push({
        event: 'standardMicrositeTrackingEvent',
        interaction: 'section_view',
        micrositeSectionNumber: id,
        micrositeSectionName: name,
      })
    },

    openModal(youtubeId) {
      this.youtubeId = youtubeId
      this.showModal = true
      if (
        window.innerWidth &&
        document.body &&
        document.body.clientWidth &&
        window.innerWidth !== document.body.clientWidth
      ) {
        document.body.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`
      }
      document.body.classList.add('modal-active')
      this.$nextTick(() => {
        this.$refs.modal.focus()
      })

      this.clickTracking({
        interaction: 'button_click',
        sectionNumber: 5,
        sectionName: '6th Job and Hexa',
        sectionContent: '6th Job Skills Video',
      })
    },
    closeModal() {
      this.showModal = false
    },

    afterModalClose() {
      document.body.style.paddingRight = ''
      document.body.classList.remove('modal-active')
    },
  },
})
</script>

<style lang="scss" scoped>
.modal-enter-active {
  animation: slide-move 0.3s ease-in;
}
.modal-leave-active {
  animation: slide-move 0.4s reverse;
}

@keyframes slide-move {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
